import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1806e9a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部问答", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = ["title", "onMouseenter", "onClick"]
const _hoisted_5 = ["title", "onMouseenter", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({'dark':_ctx.theme==='dark'})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["top-tit", {active:_ctx.active==='all'}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlerClick({Inst:'all'},'all')))
    }, _hoisted_3, 2),
    _createVNode(_component_a_collapse, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeKey) = $event)),
      bordered: false,
      expandIconPosition: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_collapse_panel, {
          key: "1",
          header: "热门概念问答 Top10",
          class: _normalizeClass({'active':_ctx.isGNTopActive})
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GNTop, (item) => {
              return (_openBlock(), _createElementBlock("p", {
                class: _normalizeClass([{'active':_ctx.active === item.Inst},{'new': item.isNew}]),
                key: item.Inst,
                title: _ctx.currentName,
                onMouseenter: ($event: any) => (_ctx.handlerMouseEnter($event,item.Name)),
                onClick: ($event: any) => (_ctx.handlerClick(item,'gn'))
              }, _toDisplayString(item.Name), 43, _hoisted_4))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_a_collapse_panel, {
          key: "2",
          header: '热门股票问答（'+_ctx.totalStock+'）',
          class: _normalizeClass({'active':_ctx.isStockTopActive})
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.StockTop, (item) => {
              return (_openBlock(), _createElementBlock("p", {
                key: item.Inst,
                class: _normalizeClass([{'active':_ctx.active === item.Inst},{'new': item.isNew}]),
                title: _ctx.currentName,
                onMouseenter: ($event: any) => (_ctx.handlerMouseEnter($event,item.Inst + ' '+item.Name)),
                onClick: ($event: any) => (_ctx.handlerClick(item,'gp'))
              }, _toDisplayString(item.Inst) + " " + _toDisplayString(item.Name), 43, _hoisted_5))
            }), 128))
          ]),
          _: 1
        }, 8, ["header", "class"])
      ]),
      _: 1
    }, 8, ["activeKey"])
  ], 2))
}